import { render } from "./FormSurveyHeader.vue?vue&type=template&id=7cbd9cb4&scoped=true"
import script from "./FormSurveyHeader.vue?vue&type=script&lang=js"
export * from "./FormSurveyHeader.vue?vue&type=script&lang=js"

import "./FormSurveyHeader.vue?vue&type=style&index=0&id=7cbd9cb4&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbd9cb4"]])

export default __exports__